<div class="breadcrumbs">
  <div>/</div>
  <div>Governance</div>
  <div>/</div>
  <div class="hasLink" [routerLink]="['/data-catalogue']">Data Catalogues</div>
  <div>/</div>
  <div>Facilis Origin AIXM 5.1</div>
  <div>/</div>
  <div class="hasLink" [routerLink]="['/data-catalogue/business-rules']">
    Business Rules
  </div>
  <div>/</div>
  <div
    *ngIf="mode === 'edit'"
    class="hasLink"
    [routerLink]="['/data-catalogue/business-rules/' + matchingRule.id]"
  >
    {{ matchingRule.title }}
  </div>
  <div *ngIf="mode === 'create'">Create</div>
</div>
<mat-toolbar class="toolbar-custom">
  <span>
    <h3 *ngIf="mode === 'edit'">Business Rule: {{ matchingRule.title }}</h3>
    <h3 *ngIf="mode === 'create'">Add New Business Rule</h3>
  </span>
  <div class="buttons-container">
    <span class="toolbar-icon" (click)="resetFields()">
      <mat-icon class="cancel-icon" color="warn" style="cursor: pointer"
        >rotate_left</mat-icon
      >
    </span>
    <span
      class="toolbar-icon"
      [routerLink]="['/data-catalogue/business-rules']"
    >
      <mat-icon class="cancel-icon" color="warn" style="cursor: pointer"
        >cancel</mat-icon
      >
    </span>
    <span class="toolbar-icon">
      <mat-icon class="save-icon" color="warn" style="cursor: pointer"
        >save</mat-icon
      >
    </span>
  </div>
</mat-toolbar>

<div class="form-wrapper">
  <form [formGroup]="form">
    <div
      *ngIf="mode === 'edit'"
      class="form-row"
      style="margin-top: 12px; width: 70%"
    >
      <mat-form-field
        *ngIf="mode === 'edit'"
        class="underline-only"
        appearance="fill"
        style="flex: 1"
      >
        <mat-label>Identifier:</mat-label>
        <input
          type="text"
          matInput
          formControlName="identifier"
          placeholder=""
          readonly
        />
      </mat-form-field>
    </div>

    <div class="form-row" style="margin-top: 12px; width: 70%">
      <mat-form-field class="underline-only" appearance="fill" style="flex: 1">
        <mat-label>Name:</mat-label>
        <input type="text" matInput formControlName="ruleName" placeholder="" />
        <mat-error *ngIf="form.get('ruleName')?.hasError('required')">
          This field is required.
        </mat-error>
        <mat-error
          *ngIf="
            form.get('ruleName')?.hasError('minlength') ||
            form.get('ruleName')?.hasError('maxlength')
          "
        >
          Name must be between 3 and 255 characters
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row" style="margin-top: 12px; width: 70%">
      <mat-form-field class="underline-only" appearance="fill" style="flex: 1">
        <mat-label>Description:</mat-label>
        <textarea
          matInput
          formControlName="description"
          rows="2"
          placeholder=""
        ></textarea>
      </mat-form-field>
    </div>

    <div class="form-row" style="margin-top: 12px; width: 70%">
      <mat-form-field class="underline-only" appearance="fill" style="flex: 1">
        <mat-label>Diagnostic:</mat-label>
        <textarea
          matInput
          formControlName="diagnostic"
          rows="2"
          placeholder=""
        ></textarea>
        <mat-error *ngIf="form.get('diagnostic')?.hasError('required')">
          This field is required.
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row" style="margin-top: 12px; width: 70%">
      <mat-form-field class="underline-only" appearance="fill" style="flex: 1">
        <mat-label>Suggestion:</mat-label>
        <textarea
          matInput
          formControlName="suggestion"
          rows="2"
          placeholder=""
        ></textarea>
      </mat-form-field>
    </div>

    <div class="form-row" style="margin-top: 12px; width: 70%">
      <mat-form-field class="underline-only" appearance="fill" style="flex: 1">
        <mat-label>Rule language</mat-label>
        <mat-select formControlName="ruleLang">
          <mat-option *ngFor="let p of ruleLangs" [value]="p">{{
            p
          }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('ruleLang')?.hasError('required')">
          This field is required.
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row" style="margin-top: 12px; width: 70%">
      <mat-form-field class="underline-only" appearance="fill" style="flex: 1">
        <mat-label>Context:</mat-label>
        <input type="text" matInput formControlName="context" placeholder="" />
        <mat-error *ngIf="form.get('context')?.hasError('required')">
          This field is required.
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row" style="margin-top: 12px; width: 70%">
      <mat-form-field class="underline-only" appearance="fill" style="flex: 1">
        <mat-label>Rule text:</mat-label>
        <textarea
          matInput
          formControlName="ruleText"
          rows="2"
          placeholder=""
        ></textarea>
        <mat-error *ngIf="form.get('ruleText')?.hasError('required')">
          This field is required.
        </mat-error>
      </mat-form-field>
      <mat-radio-group formControlName="mode" class="vertical-radio">
        <mat-radio-button value="Assert">Assert</mat-radio-button>
        <mat-radio-button value="Report">Report</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="form-row" style="margin-top: 12px; width: 70%">
      <mat-form-field class="underline-only" appearance="fill" style="flex: 1">
        <mat-label>Status</mat-label>
        <mat-select formControlName="status">
          <mat-option *ngFor="let p of statusOptions" [value]="p">{{
            p
          }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('status')?.hasError('required')">
          This field is required.
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row" style="margin-top: 12px; width: 70%">
      <mat-form-field class="underline-only" appearance="fill" style="flex: 1">
        <mat-label>AIXM Class:</mat-label>
        <input
          type="text"
          matInput
          formControlName="aixmClass"
          placeholder=""
        />
      </mat-form-field>
    </div>

    <div class="form-row" style="margin-top: 12px; width: 70%">
      <mat-form-field class="underline-only" appearance="fill" style="flex: 1">
        <mat-label>AIXM Attribute:</mat-label>
        <input
          type="text"
          matInput
          formControlName="aixmAttribute"
          placeholder=""
        />
      </mat-form-field>
    </div>
  </form>
</div>
